import {get, post,upload} from '../config/http.js'


export default {
	info :(params) => {
		return get('/admin/user/info', params)
	},

    getUserList :(params) => {
        return get('/admin/user/list', params)
    },
    getUserExamWordBookList:(params) => {
        return get('/admin/user/word/book/list', params)
    },
    userErrorWord:(params) => {
        return get('/admin/user/book/error/word', params)
    },
    userStrangeWord:(params) => {
        return get('/admin/user/book/strange/word', params)
    },
    userWordBookExamLists:(params) => {
        return get('/admin/user/exam/lists', params)
    },
    getUserExamAnalysis:(params) => {
        return get('/admin/user/exam/analysis', params)
    },
    getUserExamQuestionList:(params) => {
        return get('/admin/user/exam/question/list', params)
    },

}



// WEBPACK FOOTER //
// ./src/api/user.js